import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // 🔐 Hardcoded Admin Credentials
  const adminEmail = "admin@travira.com";
  const adminPassword = "123456";

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === adminEmail && password === adminPassword) {
      // ✅ Save Login Status
      localStorage.setItem("admin", "true");

      // ✅ Redirect to Dashboard
      navigate("/dashboard");
    } else {
      setError("Invalid Email or Password ❌");
    }
  };

  return (
    <div className="admin-container">
      <motion.div
        className="admin-card"
        initial={{ opacity: 0, y: -80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2>TraviRa Admin Panel</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="error">{error}</p>}

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
          >
            Login 🚀
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
}

export default AdminLogin;